<script lang="ts">
    import type {ScalarGridValue} from 'src/features/record-grid/lib/types';

    export let value: ScalarGridValue;
</script>

<span>{value.text}</span>